<template>
	<div class="layout">
		<slot />
	</div>
</template>
